import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { noSpinnerHeader, noSpinnerTrueValue } from '../spinner/spinner.service';
var VideoAssetsService = /** @class */ (function () {
    function VideoAssetsService(http) {
        this.http = http;
        this.endpoint = 'video-assets';
    }
    VideoAssetsService.prototype.incrementPlayCount = function (assetId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.put(this.endpoint, { assetId: assetId, command: 'incrementPlayCount' }).toPromise()];
            });
        });
    };
    VideoAssetsService.prototype.reject = function (assetId, reason) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                return [2 /*return*/, this.http.post(this.endpoint, { assetId: assetId, reason: reason }, { headers: (_a = {}, _a[noSpinnerHeader] = noSpinnerTrueValue, _a) }).toPromise()];
            });
        });
    };
    VideoAssetsService.prototype.setHasBeenDownloaded = function (assetId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.put(this.endpoint, { assetId: assetId, command: 'setHasBeenDownloaded' }).toPromise()];
            });
        });
    };
    return VideoAssetsService;
}());
export { VideoAssetsService };
